/**
 * 环形调试日志，供 DBG 浮窗展示（企微内无 DevTools 时排查「反复加载」等）。
 */

const MAX_LINES = 160;
let lines: string[] = [];
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((fn) => fn());
}

export function pushHisDebugLog(line: string): void {
  const ts = new Date().toLocaleTimeString("zh-CN", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  lines = [...lines.slice(-(MAX_LINES - 1)), `[${ts}] ${line}`];
  notify();
}

export function subscribeHisDebugLog(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function getHisDebugLogSnapshot(): readonly string[] {
  return lines;
}

export function clearHisDebugLog(): void {
  lines = [];
  notify();
}
